// extracted by mini-css-extract-plugin
module.exports = {"directoryCard":"DirectoryCard_directoryCard__2C7rU","cardText":"DirectoryCard_cardText__1jIiL","isActive":"DirectoryCard_isActive__2r1RO"};